import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormField, FormTextarea, SectionHeader } from '../../form';

const CorporateBanking: React.FC<any> = ({ formik }) => {
  const { t } = useTranslation();

  return (
    <SectionHeader
      title={t('prechecks.corporateBanking')}
      icon={
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      }
      iconBgColor="bg-cyan-100"
      iconTextColor="text-cyan-600"
      titleColor="text-cyan-600"
    >
      <FormField
        id="cbBusinessAddr"
        name="cbBusinessAddr"
        label={t('prechecks.businessAddressDifferent')}
        type="text"
        value={formik.values.cbBusinessAddr}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />

      <FormField
        id="cbPEP"
        name="cbPEP"
        label={t('prechecks.areDirectorsUBOPep')}
        type="text"
        value={formik.values.cbPEP}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.cbPEP}
        touched={formik.touched.cbPEP}
      />

      <FormTextarea
        id="cbMainClients"
        name="cbMainClients"
        label={t('prechecks.explainMainClientsPartnersSuppliers')}
        value={formik.values.cbMainClients}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.cbMainClients}
        touched={formik.touched.cbMainClients}
        rows={4}
      />

      <div className="border-t border-slate-200 pt-6 mt-6">
        <h4 className="text-lg font-semibold text-slate-700 mb-4">{t('prechecks.expectedIncomingFunds365Days')}</h4>

        <FormField
          id="cbFromCountry"
          name="cbFromCountry"
          label={t('prechecks.fromCountry')}
          type="text"
          value={formik.values.cbFromCountry}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.cbFromCountry}
          touched={formik.touched.cbFromCountry}
        />

        <FormField
          id="cbCurrency"
          name="cbCurrency"
          label={t('prechecks.currency')}
          type="text"
          value={formik.values.cbCurrency}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.cbCurrency}
          touched={formik.touched.cbCurrency}
          className="mt-6"
        />

        <FormField
          id="cbMonthlyVol"
          name="cbMonthlyVol"
          label={t('prechecks.monthlyVolume')}
          type="text"
          value={formik.values.cbMonthlyVol}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.cbMonthlyVol}
          touched={formik.touched.cbMonthlyVol}
          className="mt-6"
        />

        <FormField
          id="cbNumPayments"
          name="cbNumPayments"
          label={t('prechecks.numberOfPayments')}
          type="text"
          value={formik.values.cbNumPayments}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.cbNumPayments}
          touched={formik.touched.cbNumPayments}
          className="mt-6"
        />

        <FormTextarea
          id="cbIncomingFunds"
          name="cbIncomingFunds"
          label={t('prechecks.explainOriginIncomingFunds')}
          value={formik.values.cbIncomingFunds}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.cbIncomingFunds}
          touched={formik.touched.cbIncomingFunds}
          rows={4}
          className="mt-6"
        />
      </div>

      <div className="border-t border-slate-200 pt-6 mt-6">
        <h4 className="text-lg font-semibold text-slate-700 mb-4">{t('prechecks.expectedOutgoingFunds365Days')}</h4>

        <FormField
          id="cbToCountry"
          name="cbToCountry"
          label={t('prechecks.toCountry')}
          type="text"
          value={formik.values.cbToCountry}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.cbToCountry}
          touched={formik.touched.cbToCountry}
        />

        <FormTextarea
          id="cbOutgoingFunds"
          name="cbOutgoingFunds"
          label={t('prechecks.explainOriginOutgoingFunds')}
          value={formik.values.cbOutgoingFunds}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.cbOutgoingFunds}
          touched={formik.touched.cbOutgoingFunds}
          rows={4}
          className="mt-6"
        />
      </div>
    </SectionHeader>
  );
};

export default CorporateBanking;
